import _ from 'lodash';
import {fromJS} from 'immutable';
import React from 'react';
import { navigateAction } from 'fluxible-router';
import shallowCompare from '../../lib/shallowCompare';
import ShoppingCartActions from '../../actions/ShoppingCartActions';
import { RequestStates } from '../../stores/PaginatedStore';
import { StripeTokenPaymentMethod } from '../../models/PaymentMethod';
import OrderSummary from './OrderSummary';
import PaymentMethod from '../PaymentMethod';
import PaymentMethodModal from '../PaymentMethodModal';
import ShippingAddressModal from '../ShippingAddressModal';
import ShippingMethodSelector from './ShippingMethodSelector';
import ContactInfo from './ContactInfo';
import OrderNotes from './OrderNotes';
import styles from './index.sass';
import commonStyles from '../../../client/sass/common.sass';
import lockPng from '../images/lock.png';
import lockSvg from '../images/lock.svg';

class Checkout extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func,
    trackEvent: React.PropTypes.func,
    buildURLForRoute: React.PropTypes.func
  };

  static propTypes = {
    currentRoute              : React.PropTypes.object,
    customer                  : React.PropTypes.object,
    customerError             : React.PropTypes.object,
    customerRequestStatus     : React.PropTypes.string,
    store                     : React.PropTypes.object,
    shoppingCart              : React.PropTypes.object,
    shoppingCartError         : React.PropTypes.object,
    shoppingCartRequestStatus : React.PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      placingOrder: false,
      paymentMethodModalVisible: false,
      shippingAddressModalVisible: false,
      paymentMethod: null, // only applicable to customers not signed in
      rememberMe: true,
      billingAddress: {},
      notes: ''
    };
  }

  componentDidMount() {
    this.trackCheckoutStartedEvent();
  }

  componentWillReceiveProps(nextProps) {
    if(this.state.placingOrder && this.props.shoppingCartRequestStatus === RequestStates.Loading && nextProps.shoppingCartRequestStatus === RequestStates.Error) {
      this.setState({placingOrder: false});
    }
    if(this.props.customer !== nextProps.customer) {
      this.setState({customerError: null});
    }
    if(this.props.customerError !== nextProps.customerError) {
      this.setState({customerError: nextProps.customerError});
    }
    if(this.props.shoppingCartError !== nextProps.shoppingCartError) {
      if(nextProps.shoppingCartError.params && _.find(nextProps.shoppingCartError.params, (param) => {return param.key === 'email' || param.key === 'name' || param.key === 'phone';})) {
        this.setState({customerError: nextProps.shoppingCartError});
      } else {
        this.setState({shoppingCartError: nextProps.shoppingCartError});
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState.paymentMethodModalVisible && !this.state.paymentMethodModalVisible) {
      this.context.trackEvent('view', {value: 'checkout'});
    }
    if(prevState.shippingAddressModalVisible && !this.state.shippingAddressModalVisible) {
      this.context.trackEvent('view', {value: 'checkout'});
    }
    this.trackCheckoutStartedEvent();
  }

  trackCheckoutStartedEvent() {
    if(this._checkoutStartedEventTracked || !this.props.shoppingCart || !this.props.store) {return;}
    this.context.trackEvent('Checkout Started', {
      order_id: this.props.shoppingCart.id,
      affiliation: this.props.store.name,
      revenue: parseFloat(this.props.shoppingCart.total_text.replace('$', '')),
      currency: 'USD',
      products: this.props.shoppingCart.items.map((item) => {
        return {
          product_id: item.inventory_record.id,
          name: item.inventory_record.name,
          price: item.inventory_record.current_price,
          quantity: item.quantity
        };
      }).toJS()
    });
    this._checkoutStartedEventTracked = true;
  }

  handleOnClickPlaceOrderButton(e) {
    let { customer, shoppingCart, store } = this.props;
    let { paymentMethod } = this.state;
    let payload = {store_id: store.id};
    this.setState({customerError: null});

    payload.client_notes = this.state.notes;

    if(customer.isSignedIn()) {
      if(!customer.name) {
        return this.setState({customerError: {params: [{key: 'name', message: 'Please enter your full name'}]}});
      }
      if(!customer.phone) {
        return this.setState({customerError: {params: [{key: 'phone', message: 'Please enter your phone number'}]}});
      }
    } else {
      let contactInfo = this.refs.contactInfo.getContactInfoHash();
      if(!contactInfo.email || !contactInfo.email.match(/.@./)) {
        return this.setState({customerError: {params: [{key: 'email', message: 'Please enter your email address'}]}});
      }
      if(!contactInfo.name) {
        return this.setState({customerError: {params: [{key: 'name', message: 'Please enter your full name'}]}});
      }
      if(!contactInfo.phone) {
        return this.setState({customerError: {params: [{key: 'phone', message: 'Please enter your phone number'}]}});
      }

      payload.contact_info = contactInfo;

      if(!shoppingCart.payment_method_id) {
        if(this.state.rememberMe) {
          payload.payment_method = {stripe_token_id: paymentMethod.stripe_token_id, address: this.state.billingAddress};
        } else {
          payload.stripe_token_id = paymentMethod.stripe_token_id;
        }
      }
    }
    if(!shoppingCart.payment_method_id && !paymentMethod) {
      return this.setState({shoppingCartError: {params: [{key: 'payment_method', message: 'Please select a payment method'}]}});
    }
    if(!shoppingCart.shipping_method_id) {
      return this.setState({shoppingCartError: {params: [{key: 'shipping_method', message: 'Please select a shipping method'}]}});
    }
    if(!shoppingCart.shipping_address_id && shoppingCart.shipping_method.address_required) {
      return this.setState({shoppingCartError: {params: [{key: 'shipping_address', message: 'Please select a shipping address'}]}});
    }
    this.setState({placingOrder: true, shoppingCartError: null});
    this.context.executeAction(ShoppingCartActions.checkout, payload);
  }

  handleOnClickShippingAddressButton(e) {
    this.setState({shippingAddressModalVisible : true});
  }

  handleOnClickPaymentMethodButton(e) {
    this.setState({paymentMethodModalVisible : true});
  }

  handleOnClickContinueShoppingButton(e) {
    this.context.executeAction(navigateAction, {url: this.context.buildURLForRoute('storeLandingPage')});
  }

  handleOnCancelPaymentMethodModal() {
    this.setState({paymentMethodModalVisible : false});
  }

  handleOnCancelShippingAddressModal() {
    this.setState({shippingAddressModalVisible : false});
  }

  handleOnChangeRememberMe(e) {
    this.setState({rememberMe: e.target.checked});
  }

  handleOrderNotesChange(e) {
    this.setState({notes: e.target.value});
  }

  handleOnSavePaymentMethodModal(data) {
    this.setState({paymentMethodModalVisible : false});
    if(data) {
      if(data.paymentMethodId) {
        this.context.executeAction(ShoppingCartActions.setPaymentMethod, {
          store_id: this.props.shoppingCart.store.id,
          payment_method_id: data.paymentMethodId
        });
      } else if(data.stripeTokenId) {
        this.setState({
          billingAddress: data.address,
          paymentMethod: new StripeTokenPaymentMethod({
            stripe_token_id: data.stripeTokenId,
            stripe_token_object: data.stripeTokenObject,
            type: 'credit_card',
            details: {
              type: data.stripeTokenObject.card.brand,
              last_four: data.stripeTokenObject.card.last4,
              expiration_month: ('0' + data.stripeTokenObject.card.exp_month).slice(-2),
              expiration_year: data.stripeTokenObject.card.exp_year.toString()
            }
          })
        });
      }
    }
    this.setState({shoppingCartError: null});
  }

  handleOnSaveShippingAddressModal(data) {
    this.setState({shippingAddressModalVisible : false});
    if(data) {
      let payload = {store_id: this.props.shoppingCart.store.id};
      if(data.shippingAddressId) {
        payload.shipping_address_id = data.shippingAddressId;
      } else {
        payload.shipping_address = data.address;
      }
      this.context.executeAction(ShoppingCartActions.setShippingAddress, payload);
    }
    this.setState({shoppingCartError: null});
  }

  handleOnRemoveShippingAddressModal(addressId) {
    this.setState({shippingAddressModalVisible : false});
  }

  renderPaymentMethodButton(invalid) {
    let selectedPaymentMethodId = this.props.shoppingCart.payment_method_id;
    let paymentMethods = this.props.customer.payment_methods;
    let buttonProps = {
      className: styles.paymentMethodButton + (invalid ? ` ${styles.invalid}` : ''),
      onClick: this.handleOnClickPaymentMethodButton.bind(this),
    };
    let paymentMethodProps = {
      className: styles.paymentMethod,
      includeLeadingBullets: true
    };
    if(this.state.paymentMethod) {
      paymentMethodProps.paymentMethod = this.state.paymentMethod;
    } else {
      let selectedPaymentMethod;
      if(!selectedPaymentMethodId || !(selectedPaymentMethod = paymentMethods.find(paymentMethod => {
        return paymentMethod.id === selectedPaymentMethodId;
      }))) {
        return <button {...buttonProps}>{paymentMethods.size ? 'Select' : 'Enter'} payment method</button>;
      }
      paymentMethodProps.paymentMethod = selectedPaymentMethod;
    }

    return (
      <button {...buttonProps}>
        <span>Payment</span>
        <PaymentMethod {...paymentMethodProps} />
      </button>
    );
  }

  renderPaymentMethodModal(shoppingCart, customer) {
    if(!this.state.paymentMethodModalVisible) {return null;}
    let paymentMethodModalProps = {
      selectedPaymentMethodId : shoppingCart.payment_method_id,
      paymentMethods          : customer.payment_methods,
      storeId                 : this.props.store.id,
      customer                : customer,
      onCancel                : this.handleOnCancelPaymentMethodModal.bind(this),
      onSave                  : this.handleOnSavePaymentMethodModal.bind(this)
    };
    return <PaymentMethodModal {...paymentMethodModalProps} />;
  }

  renderShippingAddressModal(shoppingCart, customer) {
    if(!this.state.shippingAddressModalVisible) {return null;}
    let shippingAddressModalProps = {
      selectedShippingAddressId : shoppingCart.shipping_address_id,
      shippingAddresses         : customer.shipping_addresses,
      billingAddress            : this.state.billingAddress,
      storeId                   : this.props.store.id,
      defaultName               : customer.name,
      onCancel                  : this.handleOnCancelShippingAddressModal.bind(this),
      onSave                    : this.handleOnSaveShippingAddressModal.bind(this),
      onRemove                  : this.handleOnRemoveShippingAddressModal.bind(this)
    };
    return <ShippingAddressModal {...shippingAddressModalProps} />;
  }

  renderShippingAddressButton(invalid) {
    if(this.props.shoppingCart.shipping_methods.size && (!this.props.shoppingCart.shipping_method_id || !this.props.shoppingCart.shipping_method.address_required)) {return null;}
    let selectedShippingAddressId = this.props.shoppingCart.shipping_address_id;
    let shippingAddresses = this.props.customer.shipping_addresses;
    let buttonProps = {
      className : styles.shippingAddressButton + (invalid ? ` ${styles.invalid}` : ''),
      onClick   : this.handleOnClickShippingAddressButton.bind(this),
    };
    let selectedShippingAddress;
    if(!selectedShippingAddressId || !(selectedShippingAddress = shippingAddresses.find(shippingAddress => {
      return shippingAddress.id === selectedShippingAddressId;
    }))) {
      return <button {...buttonProps}>{shippingAddresses.size ? 'Select' : 'Enter'} shipping address</button>;
    }
    let shippingAddressString = selectedShippingAddress.addr1 + ' ';
    if(selectedShippingAddress.addr2) {
      shippingAddressString += (selectedShippingAddress.addr2 + ' ');
    }
    shippingAddressString += `${selectedShippingAddress.city}, ${selectedShippingAddress.state} ${selectedShippingAddress.zip_code}`;
    return (
      <button {...buttonProps}>
        <span>Ship to</span>
        <span className={styles.shippingAddress}>{shippingAddressString}</span>
      </button>
    );
  }

  renderShoppingCartError() {
    let {shoppingCartError, customerError} = this.state;
    if(!shoppingCartError || customerError) {return null;} // Only show one-type at at a time. Default to customerError (handled by ContactInfo)
    let message;
    if(shoppingCartError.params) {
      // Only show first
      message = shoppingCartError.params[0].message;
    } else {
      message = shoppingCartError.user_message || shoppingCartError.message;
    }
    return <p className={styles.error}>{message}</p>;
  }

  renderInvoice(invoice) {
    return (
      <div className={styles.invoice}>
        {invoice.map((invoiceItem, index) => {
          let className = styles.invoiceItem;
          if(invoiceItem.name === 'Total') {
            className += (' ' + styles.invoiceItemBold);
          }
          return (
            <div className={className} key={index}>
              <span className={styles.invoiceItemName} style={{color: invoiceItem.color}}>{invoiceItem.name}</span>
              <span className={styles.invoiceItemValue} style={{color: invoiceItem.color}}>{invoiceItem.value}</span>
            </div>
          );
        })}
      </div>
    );
  }

  renderRememberMeOption() {
    if(this.props.customer.isSignedIn()) {return null;}
    let id = 'rememberMe';
    let inputProps = {
      className: styles.checkbox,
      type: 'checkbox',
      name: id,
      id: id,
      checked: this.state.rememberMe,
      onChange: this.handleOnChangeRememberMe.bind(this)
    };
    let labelProps = {
      className: styles.checkboxLabel,
      htmlFor: id
    };

    return (
      <div className={styles.rememberMe}>
        <input {...inputProps} />
        <label {...labelProps}>Remember my payment information</label>
        <p className={styles.subtext}>We'll email you a link to finish creating your account when you get a chance.</p>
      </div>
    );
  }

  renderAlerts(shoppingCart) {
    if(!shoppingCart) {return null;}
    return shoppingCart.alerts.map((alert, index) => {
      let props = {
        className: styles.alert,
        key: index
      };
      return <p {...props}>{alert.message}</p>;
    });
  }

  render() {
    let { customer, shoppingCart, store } = this.props;
    let { shoppingCartError } = this.state;
    let placeOrderButtonProps = {
      className   : styles.placeOrderButton,
      onClick     : this.handleOnClickPlaceOrderButton.bind(this),
      disabled    : !shoppingCart || this.props.shoppingCartRequestStatus === RequestStates.Loading || this.state.placingOrder
    };
    let placeOrderButtonContent = this.props.shoppingCartRequestStatus === RequestStates.Loading ? <span className="loading-spinner--white" /> : 'Place Order';
    let contactInfoProps = {
      ref: 'contactInfo',
      customer: customer,
      store: store,
      error: this.state.customerError,
      requestStatus: this.props.customerRequestStatus
    };

    let orderNotesProps = {
      handleOrderNotesChange: this.handleOrderNotesChange.bind(this),
      notes: this.state.notes,
      error: this.state.customerError,
      requestStatus: this.props.customerRequestStatus
    };

    let invalidFields = {};
    if(shoppingCartError && shoppingCartError.params) {
      _.each(shoppingCartError.params, (hash) => {
        invalidFields[hash.key] = hash.message;
      });
    }
    let shippingMethodSelectorProps = {
      shoppingCart: shoppingCart,
      customer: customer,
      invalid: !!invalidFields.shipping_method
    };
    let innerContainer;

    if(shoppingCart && shoppingCart.items.size) {
      innerContainer = (
        <div className={styles.innerContainer}>
          <ContactInfo {...contactInfoProps} />
          <ShippingMethodSelector {...shippingMethodSelectorProps} />
          {this.renderPaymentMethodButton(!!invalidFields.payment_method)}
          {this.renderShippingAddressButton(!!invalidFields.shipping_address)}
          <OrderNotes {...orderNotesProps} />
          {this.renderInvoice(shoppingCart.invoice)}
          {this.renderShoppingCartError()}
          {this.renderAlerts(shoppingCart)}
          <p className={styles.securityMessage}><img src={lockPng} srcSet={lockSvg} />Your order is secured with encryption</p>
          <button {...placeOrderButtonProps}>{placeOrderButtonContent}</button>
          {this.renderRememberMeOption()}
        </div>
      );
    } else {
      let continueShoppingButtonProps = {
        className: styles.continueShoppingButton,
        onClick: this.handleOnClickContinueShoppingButton.bind(this)
      };
      innerContainer = (
        <div className={styles.innerContainer}>
          <p className={styles.empty}>Your bag is empty</p>
          <div className={styles.buttonsContainer}>
            <button {...continueShoppingButtonProps}>Keep shopping</button>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.checkout}>
        <div className={styles.storeLogo}><img src={store.logo_photo_hash.getClosestToTarget(250)} /></div>
        <OrderSummary shoppingCart={shoppingCart} />
        {innerContainer}
        {this.renderPaymentMethodModal(shoppingCart, customer)}
        {this.renderShippingAddressModal(shoppingCart, customer)}
      </div>
    );
  }
}

export default Checkout;



// WEBPACK FOOTER //
// banquet/components/Checkout/index.js